import { configureStore } from "@reduxjs/toolkit";
import HeaderReducer from './headers'

const store = configureStore({
    reducer: {header: HeaderReducer}
})

export default store;